<template>
  <div class="content">
    <PreviewNewImage />

    <PreviewImageFooter
      :isDraft="isDraft"
    />

    <PreviewResourceInfo
      :isNewResource="isNewResource"
    />

    <v-row class="expansion-panel">
      <v-col
        cols="12"
        class="expansion-panel__wrapper"
      >
        <AdsExpansionPanel
          v-model="panel"
          :items="expansionPanelItems"
          multiple
        >
          <template #contentOverview>
            <PreviewCardOverview />
          </template>
          <template #contentCurriculumAlignment>
            <PreviewCardCurriculumAlignment />
          </template>
          <template #contentProgressions>
            <PreviewProgressions />
          </template>
          <template #contentKeywords>
            <PreviewKeywords />
          </template>
        </AdsExpansionPanel>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {AdsExpansionPanel} from '@nswdoe/doe-ui-core';
import PreviewNewImage from './PreviewNewImage';
import PreviewImageFooter from '@/views/MyResourceDetailsPage/Preview/PreviewImageFooter';
import PreviewResourceInfo from '@/views/MyResourceDetailsPage/Preview/PreviewResourceInfo';
import PreviewCardOverview from '@/views/MyResourceDetailsPage/Preview/PreviewCardOverview';
import PreviewCardCurriculumAlignment from '@/views/MyResourceDetailsPage/Preview/PreviewCardCurriculumAlignment';
import PreviewProgressions from '@/views/MyResourceDetailsPage/Preview/PreviewProgressions';
import PreviewKeywords from '@/views/MyResourceDetailsPage/Preview/PreviewKeywords';

export default {
  name: 'Preview',
  components: {
    PreviewResourceInfo,
    PreviewImageFooter,
    PreviewNewImage,
    AdsExpansionPanel,
    PreviewCardOverview,
    PreviewCardCurriculumAlignment,
    PreviewProgressions,
    PreviewKeywords
  },
  props: {
    isNewResource: {
      type: Boolean,
      default: true
    },
    isDraft: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expansionPanelItems: [
        {
          id: 'Overview',
          title: 'Overview',
        },
        {
          id: 'CurriculumAlignment',
          title: 'Syllabus /  Curriculum Alignment',
        },
        {
          id: 'Progressions',
          title: 'National Literacy and/or Numeracy Learning Progression(s)',
        },
        {
          id: 'Keywords',
          title: 'Keywords',
        }
      ],
      panel: [0]
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";

.row {
  margin-top: 0;
  margin-bottom: 36px;

  .col-12 {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.content {
  width: 80%;
}

::v-deep.theme--light {
  .v-btn {
    &:hover {
      &::before {
        opacity: 0 !important;
      }
    }
  }
}

@media only screen and (max-width: 960px) {
  .row {
    margin-bottom: 24px;
  }

  .content {
    width: 100%;

    .autocomplete__wrapper {
      margin-top: 24px;
    }
  }
}

@media only screen and (max-width: 600px) {
}
</style>
